// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"163":"774df40a","270":"a5207a84","354":"84536aa8"}[chunkId] + ".chunk.js";
};